import { z } from "zod/v4";

export const reportReasonSchema = z.enum([
	"spam",
	"sexual",
	"harassment",
	"hate",
	"violence",
	"other",
]);
export type ReportReason = z.infer<typeof reportReasonSchema>;

export const reportStatusSchema = z.enum(["open", "dismissed", "actioned"]);
export type ReportStatus = z.infer<typeof reportStatusSchema>;

export const clubReportSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	reporter_id: z.string().uuid(),
	reason: reportReasonSchema,
	details: z.string().nullable().optional(),
	status: reportStatusSchema,
	resolved_by: z.string().uuid().nullable().optional(),
	resolved_at: z.coerce.date().nullable().optional(),
	created_at: z.coerce.date(),
	club_name: z.string().nullable().optional(),
	club_avatar_url: z.string().nullable().optional(),
	reporter_name: z.string().nullable().optional(),
	reporter_email: z.string().nullable().optional(),
	reporter_avatar_url: z.string().nullable().optional(),
});
export type ClubReport = z.infer<typeof clubReportSchema>;

export const clubReportSummarySchema = z.object({
	club_id: z.string().uuid(),
	club_name: z.string(),
	club_avatar_url: z.string().nullable().optional(),
	open_count: z.number().int().nonnegative(),
	total_count: z.number().int().nonnegative(),
	last_reported_at: z.coerce.date(),
	reasons: z.array(reportReasonSchema),
});
export type ClubReportSummary = z.infer<typeof clubReportSummarySchema>;

export const playerReportSchema = z.object({
	id: z.string().uuid(),
	reported_id: z.string().uuid(),
	reporter_id: z.string().uuid(),
	reason: reportReasonSchema,
	details: z.string().nullable().optional(),
	status: reportStatusSchema,
	resolved_by: z.string().uuid().nullable().optional(),
	resolved_at: z.coerce.date().nullable().optional(),
	created_at: z.coerce.date(),
	reported_name: z.string().nullable().optional(),
	reported_avatar_url: z.string().nullable().optional(),
	reporter_name: z.string().nullable().optional(),
	reporter_email: z.string().nullable().optional(),
	reporter_avatar_url: z.string().nullable().optional(),
});
export type PlayerReport = z.infer<typeof playerReportSchema>;

export const playerReportSummarySchema = z.object({
	reported_id: z.string().uuid(),
	reported_name: z.string().nullable().optional(),
	reported_avatar_url: z.string().nullable().optional(),
	open_count: z.number().int().nonnegative(),
	total_count: z.number().int().nonnegative(),
	last_reported_at: z.coerce.date(),
	reasons: z.array(reportReasonSchema),
});
export type PlayerReportSummary = z.infer<typeof playerReportSummarySchema>;

export const messageReportSchema = z.object({
	id: z.string().uuid(),
	message_id: z.string().uuid(),
	game_id: z.string().uuid().nullable().optional(),
	chat_room_id: z.string().uuid().nullable().optional(),
	reason: reportReasonSchema,
	details: z.string().nullable().optional(),
	status: reportStatusSchema,
	created_at: z.coerce.date(),
	resolved_at: z.coerce.date().nullable().optional(),
	resolved_by: z.string().uuid().nullable().optional(),
	reporter_id: z.string().uuid(),
	reporter_name: z.string(),
	reporter_email: z.string(),
	reporter_avatar_url: z.string().nullable().optional(),
	author_id: z.string().uuid(),
	author_name: z.string(),
	message_content: z.string().nullable().optional(),
	message_hidden: z.boolean(),
});
export type MessageReport = z.infer<typeof messageReportSchema>;

export const createReportSchema = z.object({
	reason: reportReasonSchema,
	details: z.string().max(2000).optional(),
});
export type CreateReport = z.infer<typeof createReportSchema>;

export const updateReportStatusSchema = z.object({
	status: z.enum(["dismissed", "actioned"]),
});
export type UpdateReportStatus = z.infer<typeof updateReportStatusSchema>;
